import React, { useRef } from "react";
import { useAuth } from "@/lib/AuthContext";
import FestivalBackground from "@/components/festival/FestivalBackground";
import FestivalHero from "@/components/festival/FestivalHero";
import GiveawayHeader from "@/components/giveaway/GiveawayHeader";
import SignUpCTASection from "@/components/campaign/SignUpCTASection";
import LandingTasksSection from "@/components/campaign/LandingTasksSection";

export default function Festival() {
  const tasksRef = useRef(null);
  const { isAuthenticated: loggedIn } = useAuth();

  const scrollToTasks = () => tasksRef.current?.scrollIntoView({ behavior: "smooth" });

  return (
    <div style={{ minHeight: "100vh", background: "#0a0010" }}>
      <FestivalBackground />
      <GiveawayHeader />
      <FestivalHero onScrollToForm={loggedIn ? scrollToTasks : undefined} loggedIn={loggedIn} />
      {loggedIn ? (
        <div ref={tasksRef}>
          <LandingTasksSection theme="festival" />
        </div>
      ) : (
        <SignUpCTASection theme="festival" returnPath="/Festival" />
      )}
    </div>
  );
}